import React, { useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    getDepartments, createDepartment, resetDepartment, resetNewlycreatedDepartmentId, deleteDepartment, 
    openDepartment,
    openDepartmentDashboard, 
} from "../store/actions/departmentActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../assets/images/loader.svg";
import { useHistory } from 'react-router-dom';
import { LuPlus } from "react-icons/lu";



import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import Overlay from "../components/Departments/Overlay";
//import DepartmentTable from "../components/Departments/DepartmentTable";
import DepartmentCard from "../components/Departments/DepartmentCard";

function Departments(props) {

    const { token, getDepartmentsFN, departments, department_id, resetDepartmentFN, createDepartmentFN, deleteDepartmentFN, openDepartmentFN, department_dashboard_data, newlycreatedDepartmentId, resetNewlycreatedDepartmentIdFN } = props;

    const history = useHistory();

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);

    const [currentDepartment, setCurrentDepartment] = useState(null);

    const closeCreation = () => {
        getDepartmentsFN();
        resetDepartmentFN();
        resetNewlycreatedDepartmentIdFN();
        setIsPopupOpen(false);

    }


    useEffect(() => {
            if (newlycreatedDepartmentId) {
                ////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
                let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
                ////console.log("department", department);
                resetNewlycreatedDepartmentIdFN();
                setCurrentDepartment(department);
                setIsPopupOpen(true);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [newlycreatedDepartmentId]);

    useEffect(() => {
        getDepartmentsFN();
    }, []);

    useEffect(() => {
        //alert(department_id);
        if (department_id) {
            let department = departments && departments.find(department => department.department_id === department_id);

            //////console.log(department_id, department);
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
    }, [department_id]);


    useEffect(() => {
        if (department_dashboard_data) {
            history.push({ pathname: "/units", state: { departmentfromredirect: department_dashboard_data } });
        }
    }, [department_dashboard_data]);

    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
    }, [newlycreatedDepartmentId]);

    const [qDept, setQDept] = useState("");
    const [view, setView] = useState("grid"); // "grid" | "table"

    const norm = (v) =>
        String(v ?? "")
            .normalize("NFD")
            .replace(/\p{Diacritic}/gu, "")
            .toLowerCase()
            .replace(/\s+/g, " ")
            .trim();

    const filteredDepartments = useMemo(() => {
        const q = norm(qDept);
        if (!q) return departments || [];
        return (departments || []).filter((d) => {
            const hay = [
                d?.name,
                d?.description,
                d?.head_name ?? [d?.head_first_name, d?.head_last_name].filter(Boolean).join(" "),
                `${d?.employee_count ?? d?.employees ?? ""}`,
            ]
                .map(norm)
                .join(" ");
            return hay.includes(q);
        });
    }, [departments, qDept]);

    const appetiteClass = (val) => {
        const v = String(val ?? "").toLowerCase();
        if (v === "hungry") return "text-[#BB133E]";
        if (v === "open") return "text-[#D6606E]";
        if (v === "cautious") return "text-[#FED9B7]";
        if (v === "minimalist") return "text-[#00AFB9]";
        return "text-[#0081A7]"; // default
    };


    return token ? (
        <>
           <div className="flex flex-col w-full px-12 md:px-12 2xl:px-12 py-6 overflow-auto">
                <div className="h-full w-full mt-2">
                    {/* Header */}
                    <div className="flex items-start justify-between">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">Departments</h2>
                            <p className="text-sm text-gray-500">Manage organizational departments</p>
                        </div>

                        <div className="flex items-center gap-2">
                            {/* View toggle with icons */}
                            <div
                                className="hidden sm:flex items-center bg-gray-100/80 rounded-full p-1.5 shadow-inner ring-1 ring-gray-200"
                                role="tablist"
                            >
                                <button
                                    onClick={() => setView("grid")}
                                    role="tab"
                                    aria-selected={view === "grid"}
                                    className={`flex items-center gap-1.5 px-3.5 py-1.5 text-sm rounded-full transition ${view === "grid"
                                        ? "bg-white text-gray-900 shadow"
                                        : "text-gray-600 hover:text-gray-900"
                                        }`}
                                >
                                    <svg
                                        className="w-4 h-4"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                    >
                                        <rect x="3" y="3" width="7" height="7" rx="1.5" />
                                        <rect x="14" y="3" width="7" height="7" rx="1.5" />
                                        <rect x="3" y="14" width="7" height="7" rx="1.5" />
                                        <rect x="14" y="14" width="7" height="7" rx="1.5" />
                                    </svg>
                                    Grid
                                </button>
                                <button
                                    onClick={() => setView("table")}
                                    role="tab"
                                    aria-selected={view === "table"}
                                    className={`flex items-center gap-1.5 px-3.5 py-1.5 text-sm rounded-full transition ${view === "table"
                                        ? "bg-white text-gray-900 shadow"
                                        : "text-gray-600 hover:text-gray-900"
                                        }`}
                                >
                                    <svg
                                        className="w-4 h-4"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                    >
                                        <path d="M3 6h18M3 12h18M3 18h18" />
                                    </svg>
                                    Table
                                </button>
                            </div>

                            {/* Add Department */}
                            <button
                                onClick={() => createDepartmentFN()}
                                className="inline-flex items-center gap-2 h-10 px-5 rounded-lg bg-[#0B0B0F] text-white hover:opacity-90 transition"
                            >
                                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                    <path strokeWidth="2" d="M12 5v14M5 12h14" />
                                </svg>
                                <span className="text-sm font-medium">Add Department</span>
                            </button>
                        </div>
                    </div>

                    {/* Search bar */}
                    <div className="mt-4">
                        <div className="relative">
                            <input
                                value={qDept}
                                onChange={(e) => setQDept(e.target.value)}
                                placeholder="Search departments..."
                                className="w-full h-10 pl-9 pr-3 rounded-lg border border-gray-200 bg-gray-100/60 focus:bg-white focus:border-gray-300 focus:outline-none"
                            />
                            <svg
                                className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                            >
                                <circle cx="11" cy="11" r="7" strokeWidth="1.8" />
                                <path d="M20 20l-3.5-3.5" strokeWidth="1.8" />
                            </svg>
                        </div>
                    </div>

                    {/* Table / Grid */}
                    <div className="mt-6">
                        {view === "table" ? (
                            <div className="rounded-2xl border border-gray-200 overflow-hidden bg-white shadow-sm">
                                <table className="w-full text-sm text-gray-800">
                                    <thead className="bg-white border-b border-gray-200">
                                        <tr>
                                            <th className="text-left font-medium text-gray-700 px-6 py-3.5">Name</th>
                                            <th className="text-left font-medium text-gray-700 px-6 py-3.5">Definition</th>
                                            <th className="text-left font-medium text-gray-700 px-6 py-3.5">Employees</th>
                                            <th className="text-left font-medium text-gray-700 px-6 py-3.5">Risk Appetite</th>
                                            <th className="text-left font-medium text-gray-700 px-6 py-3.5 w-[150px]">Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody className="bg-white">
                                        {filteredDepartments.map((d) => {
                                            const id = d.department_id;
                                            const employees = d?.employee_count ?? d?.employees ?? "-";
                                            const definition = d?.definition ?? d?.description ?? "-";
                                            const appetite =
                                                d?.risk_appetite ?? d?.riskAppetite ?? d?.risk_appetite_level ?? "-";

                                            return (
                                                <tr
                                                    key={id}
                                                    className="border-t border-gray-100 hover:bg-gray-50 transition-colors"
                                                >
                                                    <td className="px-6 py-3.5 text-gray-900 font-medium">{d?.name ?? "-"}</td>

                                                    <td className="px-6 py-3.5 text-gray-700">
                                                        <span className="line-clamp-2">{definition}</span>
                                                    </td>

                                                    <td className="px-6 py-3.5 text-gray-700">{employees}</td>

                                                    {/* Risk Appetite pill with your colors */}
                                                    <td className="px-6 py-3.5">
                                                        {appetite === "-" ? (
                                                            <span className="text-gray-500">-</span>
                                                        ) : (
                                                            <span
                                                                className={
                                                                    "inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border bg-white " +
                                                                    appetiteClass(appetite) +
                                                                    " border-current"
                                                                }
                                                            >
                                                                <span className={"inline-block w-1.5 h-1.5 rounded-full " + appetiteClass(appetite)} />
                                                                {String(appetite)}
                                                            </span>
                                                        )}
                                                    </td>

                                                    {/* Actions (bigger, always visible) */}
                                                    <td className="px-6 py-3.5">
                                                        <div className="flex items-center gap-3">
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); openDepartmentFN?.(id); }}
                                                                className="p-1.5 rounded-md hover:bg-gray-100"
                                                                title="Edit"
                                                            >
                                                                <svg className="w-5 h-5 text-gray-700" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                                    <path strokeWidth="1.8" d="M12 20h9" />
                                                                    <path strokeWidth="1.8" d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                                                </svg>
                                                            </button>

                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); deleteDepartmentFN?.(id); }}
                                                                className="p-1.5 rounded-md hover:bg-red-50"
                                                                title="Delete"
                                                            >
                                                                <svg className="w-5 h-5 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                                    <path strokeWidth="1.8" d="M3 6h18" />
                                                                    <path strokeWidth="1.8" d="M8 6v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" />
                                                                    <path strokeWidth="1.8" d="M10 11v6M14 11v6" />
                                                                    <path strokeWidth="1.8" d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                        {filteredDepartments.length === 0 && (
                                            <tr>
                                                <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                                                    No departments match your search.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>


                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 md:gap-10">
                                {filteredDepartments.map((department) => (
                                    <DepartmentCard key={department.department_id} department={department} />
                                ))}
                            </div>

                        )}
                    </div>

                    {/* Footer */}
                    <div className="text-sm text-gray-500 mt-4">
                        Showing {filteredDepartments.length} of {(departments || []).length} departments
                    </div>
                </div>
            </div>

            <Popup
                open={isPopupOpen}
                onClose={closeCreation}
                contentStyle={{
                    overflow: "auto",
                    maxHeight: "80vh",
                    width: "810px",
                    marginTop: "14vh",
                }}
            >
                <Overlay close={closeCreation} department={currentDepartment} edit={true} />
            </Popup>
        </>
    ) : (
        <Redirect to="/login" />
    );





}

const mapStateToProps = (state) => {
    console.log("department_dashboard_data ", state.department)
    return {

        token: state.auth.token,
        departments: state.department.departments,
        department_id: state.department.department_id,
        department_dashboard_data: state.department.department_dashboard_data,
        newlycreatedDepartmentId: state.department.newlycreatedDepartmentId



    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getDepartmentsFN: () => dispatch(getDepartments()),
        resetDepartmentFN: () => dispatch(resetDepartment()),
        createDepartmentFN: () => dispatch(createDepartment()),
        resetNewlycreatedDepartmentIdFN: () => dispatch(resetNewlycreatedDepartmentId()),
        deleteDepartmentFN: (id) => dispatch(deleteDepartment(id)),
        openDepartmentFN: (id) => dispatch(openDepartment(id)),
        createDepartmentFN: () => dispatch(createDepartment()),
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Departments);

